import createDuck from '../../../lib/ducks/remoteDuck'
import Lookbook from '../../../lib/api/lookbook'

export default createDuck({
  namespace: 'content',
  store: 'lookbook',
  fetchCallback: Lookbook.get,
})
